import React from "react";
import PublicNavBar from "../public_header/NarBar";
import PublicSidebar from "../public_sidebar/PublicSidebar";
import { useLayoutSidebarStore } from "../../store/layout/useLayoutSidebarStore";

interface PublicSharedLayoutProps {
  children: React.ReactNode;
}

const PublicSharedLayout: React.FC<PublicSharedLayoutProps> = ({ children }) => {
  const { sidebarOpen, setSidebarOpen } = useLayoutSidebarStore();

  return (
    <div className="bg-main min-h-screen overflow-x-hidden">
      <PublicNavBar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex">
        <PublicSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <div className="flex-1 p-4 overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PublicSharedLayout;
